/**
 * Types and values for learner preferences in wizard, preference center.
 */

export enum Intent {
  Exploring = "exploring",
  NewUser = "new_user",
  NewSkills = "new_skills",
  Certification = "certification",
  GetHelp = "get_help",
  GrowBusiness = "grow_business",
}

export enum Level {
  Beginner = "beginner",
  Intermediate = "intermediate",
  Advanced = "advanced",
}

export enum Solution {
  Sales = "sales",
  Data = "data",
  Automation = "automation",
  CustomerSuccess = "customer_success",
  Relationships = "relationships",
  Ai = "ai",
}

export enum Product {
  CommerceCloud = "Commerce Cloud",
  DataCloud = "Data Cloud",
  Einstein = "Einstein",
  FinancialServicesCloud = "Financial Services Cloud",
  MarketingCloud = "Marketing Cloud",
  MuleSoft = "MuleSoft",
  NonprofitCloud = "Nonprofit Cloud",
  SalesCloud = "Sales Cloud",
  SalesforcePlatform = "Salesforce Platform",
  ServiceCloud = "Service Cloud",
  Slack = "Slack",
  Tableau = "Tableau",
}

export enum Role {
  Admin = "Admin",
  Architect = "Architect",
  BusinessAnalyst = "Business Analyst",
  Consultant = "Consultant",
  CustomerService = "Customer Service",
  Cybersecurity = "Cybersecurity",
  Designer = "Designer",
  Developer = "Developer",
  EndUser = "End User",
  Marketer = "Marketer",
  Sales = "Sales",
  Service = "Service",
}

export type Preferences = {
  intent?: Intent;
  solution?: Solution[];
  role?: Role[];
  product?: Product[];
  level?: Level;
  activeTrail?: string;
};
